import React, { Component } from 'react';

import ReactDOM from 'react-dom';

import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

import { CreateTestCycleDialog } from '@qality/common-components';
import { DialogExportTestCasesPage } from '@qality/common-pages';
import { StorageOfUniqueServices } from '@qality/common-service';
import '@qality/common-style/design-tokens/tokens.scss';
import { ServerComponents } from '@qality/server-components';
import { ServerDialogs } from '@qality/server-dialogs';
import { ServerModels } from '@qality/server-models';
import { ServerServices } from '@qality/server-services';

import './server-hacks.scss';

type OpenCreateTestCycleCustomData = {
  isAddingTestCases: boolean;
  onDialogClose: (data) => void;
};

function closeDialog() {
  ReactDOM.unmountComponentAtNode(
    window.document.getElementById(
      'com_soldevelo_apps_test-management_create-test-cycle-dialog-node'
    )
  );
}

const defaultCustomData: OpenCreateTestCycleCustomData = {
  isAddingTestCases: false,
  onDialogClose: () => null,
};

async function startRender(customData = defaultCustomData) {
  ServerComponents.init();
  ServerDialogs.init();
  ServerServices.init();
  ServerModels.init();
  await StorageOfUniqueServices.get('WindowOriginService').init();

  ReactDOM.render(
    <CreateTestCycleDialog
      isAddingTestCases={customData.isAddingTestCases}
      onClose={async (data) => {
        customData.onDialogClose(data);
        closeDialog();
      }}
    />,
    window.document.getElementById(
      'com_soldevelo_apps_test-management_create-test-cycle-dialog-node'
    )
  );
}

class ExportTestCasesDialog extends Component {
  onCancel = () => {
    ReactDOM.unmountComponentAtNode(
      window.document.getElementById(
        'com_soldevelo_apps_test-management_export-test-cycles-dialog_container'
      )
    );
  };

  render() {
    return <DialogExportTestCasesPage onCloseDialog={this.onCancel} />;
  }
}

async function startRender2() {
  ServerComponents.init();
  ServerDialogs.init();
  ServerServices.init();
  ServerModels.init();
  await StorageOfUniqueServices.get('WindowOriginService').init();

  ReactDOM.render(
    <div>
      <ModalTransition>
        <ModalDialog>
          <ExportTestCasesDialog />
        </ModalDialog>
      </ModalTransition>
    </div>,
    window.document.getElementById(
      'com_soldevelo_apps_test-management_export-test-cycles-dialog_container'
    )
  );
}

export default {
  openCreateTestCycleDialog(customData?: OpenCreateTestCycleCustomData): void {
    const dialog = new window.AJS.Dialog({
      width: 400,
      height: 200,
      id: 'qality-create-test-cycle',
      closeOnOutsideClick: false,
    });
    dialog.addPanel(
      'Panel 1',
      '<div id="com_soldevelo_apps_test-management_create-test-cycle-dialog-node" />',
      'panel-body'
    );
    dialog.show();
    startRender(customData);
    dialog.hide();
  },
  openExportTestCasesDialog(): void {
    const dialog = new window.AJS.Dialog({
      width: 400,
      height: 200,
      id: 'qality-export-test-cycles',
      closeOnOutsideClick: false,
    });
    dialog.addPanel(
      'Panel 2',
      '<div id="com_soldevelo_apps_test-management_export-test-cycles-dialog_container" />',
      'panel-body'
    );
    dialog.show();
    startRender2();
    dialog.hide();
  },
};
